import * as components from './components'

export default [
  {
    path: '/item/create',
    component: components.CreateItem,
    name: 'createItem',
    props: true
  },
  {
    path: '/item/list',
    component: components.ListItem,
    name: 'listItem',
    props: true
  },
  {
    path: '/item/:reference',
    component: components.CreateItem,
    name: 'editItem',
    props: true
  },
  {
    path: '/assessment/create',
    component: components.CreateAssessment,
    name: 'createAssessment',
    props: true
  },
  {
    path: '/assessment/:uuid',
    component: components.AssessmentDetail,
    name: 'assessmentDetail',
    props: true
  },
  {
    path: '/assessment/:uuid/edit',
    component: components.EditAssessment,
    name: 'editAssessment',
    props: true
  },
  {
    path: '/launchAssessment/:uuid',
    component: components.LaunchAssessment,
    name: 'launchAssessment',
    props: true
  },
  {
    path: '/diagnosticLogicMapping/upload',
    component: components.DiagnosticLogicMappingUpload,
    name: 'diagnosticLogicMappingUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/assessment/routes.js